import React from "react";

const Fotterbackground = () => {
  return (
    <div>
      <img
        className="footer-img"
        style={{ height: "100%", width: "100%" }}
        src={
          "https://roam.qodeinteractive.com/wp-content/uploads/2017/08/background-image.png"
        }
        alt=""
      />
    </div>
  );
};

export default Fotterbackground;
